var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CognitoIdentityProviderClient, InitiateAuthCommand, } from '@aws-sdk/client-cognito-identity-provider';
export const getCognitoToken = (username, password, options) => __awaiter(void 0, void 0, void 0, function* () {
    const cognitoClient = new CognitoIdentityProviderClient({
        region: options.region,
    });
    const { AuthenticationResult } = yield cognitoClient.send(new InitiateAuthCommand({
        AuthFlow: 'USER_PASSWORD_AUTH',
        ClientId: options.clientId,
        AuthParameters: {
            USERNAME: username,
            PASSWORD: password,
        },
    }));
    return AuthenticationResult;
});
//# sourceMappingURL=getCognitoToken.js.map